import React, { useEffect, useState } from "react";
import cx from "classnames";
import styles from "./accountonboarding.module.scss";
import { Form, FormField, Container, Button, Dropdown} from "semantic-ui-react";
import Select from "react-select";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import ConfirmModal from "components/ui/ConfirmModal";

import useCaseOptions from 'data/useCases.json'

import { toast } from "react-toastify";
import { updateOnboardingDetails } from "actions/accounts";
import exclamatory from '../../../../../images/exclamatory.svg'
import { useParams} from "react-router-dom";
import SaveChanges from "components/ui/Buttons/SaveButton";

const initData = {
  onboardingUserId: null,
  useCases: []
}
const statusOptions = [
  { key: 'Not Started', text: 'Not Started', value: 'Not Started' },
  { key: 'In Progress', text: 'In Progress', value: 'In Progress' },
  { key: 'Completed', text: 'Completed', value: 'Completed' },
];
export default function AccountOnboarding({ account }) {
  const dispatch = useDispatch()

  const [error, setError] = useState(null);
  const [initialRender, setInitialRender] = useState(true);

  const [open, setOpen] = useState(false);

  const [accountObj, setAccountObj] = useState(initData);
  const [initAccountObj, setInitAccountObj] = useState(initData);

  const [managerOptions, setManagerOptions] = useState([]);

  const updatingAccount = useSelector((state) => state.accounts.updatingOnboarding);
  const adminAppUsers = useSelector((state) => _.get(state, "accounts.adminAppUsers"));

  const [disableSave, setDisableSave] = useState(false);
  const [onboardingData, setOnboardingData] = useState({ manualCase: '' });
  const [status, setStatus] = useState("");
  const [linkData, setLinkData] = useState({ gsUrl: '' });
  const manualcase =  useSelector((state) => _.get(state, "accounts.account.manualCase"));
  const statusUpdate = useSelector((state) => _.get(state, "accounts.account.statusOptions"));
  const linkUpdate = useSelector((state) => _.get(state, "accounts.account.gsUrl"));
  const params = useParams();
  
  useEffect(() => {
    onSetManagerOptions();
  }, []);

  useEffect(() => {
    onSetOnboarding();
    setInitialRender(false);
    setError(null);
  }, [account]);

  useEffect(() => {
    onSetManagerOptions();
  }, [adminAppUsers]);

  useEffect(() => {
    if (!initialRender && updatingAccount && !updatingAccount.updating) {

      if (updatingAccount.success) {
        toast.success(`Successfully updated ${account.name}`);
      } else {
        toast.error(`failed to update ${account.name}`);
      }
    }
  }, [updatingAccount]);

  useEffect(() => {
    if (_.isEqual(initAccountObj, accountObj)) {
      setDisableSave(true);
    }
    else {
      setDisableSave(false);
    }
  }, [accountObj])

  useEffect(() => {

    setOnboardingData({ ...onboardingData, manualCase: manualcase });
    setStatus(statusUpdate);
    setLinkData({ ...linkData, gsUrl: linkUpdate })
  }, [manualcase, statusUpdate])

  const onSetManagerOptions = () => {
    if (!_.isEmpty(adminAppUsers) && _.isEmpty(managerOptions)) {
      let options = _.map(adminAppUsers, (user) => {
        return { key: user.id, text: user.name, value: user.id };
      });
  
      setManagerOptions(options);
    } 
  }

  const onSetOnboarding = () => {

    if (account !== null && account !== undefined) {

      let onboardingUserId = (account.onboardingManager ? account.onboardingManager.id : null);
      let useCases = getSelectedUsecases(account.useCases);

      let data = {
        onboardingUserId,
        useCases
      };

      setAccountObj(data);
      setInitAccountObj(data);
    }

  }

  const getSelectedUsecases = (useCases) => {

    let selected = [];

    if (_.isEmpty(useCases)) {
      return selected;
    }

    _.forEach(useCases, (useCase) => {
      const found = _.find(useCaseOptions, { label: useCase });
      if (found) {
        selected.push(found)
      }
      else {
        selected.push({
          text: useCase,
          label: useCase
        });
      }
    })

    return selected;
  }

  const handleUseCaseChange = (useCases) => {
    setAccountObj({ ...accountObj, useCases });
  };

  const onCancelChanges = (e) => {
    e.preventDefault();

    setOpen(false);
  };

  const onReset = (e) => {
    e.preventDefault();

    onSetOnboarding();
    setError(null);

    setOpen(false);

    if (manualcase) {
      setOnboardingData({ ...onboardingData, manualCase: manualcase });
    } else {
      setOnboardingData({ ...onboardingData, manualCase: '' });
    }
    if (statusUpdate) {
      setStatus(_.get(account, "statusOptions"));
    } else {
      setStatus("");
    }
    if (linkUpdate) {
      setLinkData({ ...linkData, gsUrl: linkUpdate });
    } else {
      setLinkData({ ...linkData, gsUrl: '' });
    }
  };

  const handleSubmit = () => {

    let data = {};
    data.onboardingUserId = accountObj.onboardingUserId;
    data.useCases = [];

    if (!_.isEmpty(accountObj.useCases)) {
      data.useCases = _.map(accountObj.useCases, "value");
    }

    data.manualCase = onboardingData.manualCase;
    data.statusOptions = status;
    data.gsUrl = linkData.gsUrl;
    dispatch(updateOnboardingDetails({ id: account.id, data: data }))
    setOpen(false);
  }

  const onSaveChanges = (e) => {
    if (!accountObj.onboardingUserId) {
      setError("Please select a manager");
      setDisableSave(true);
      return;
    }
    
    setDisableSave(false);
    setError(null);

    setOpen(true);
  };
  const handleLinkChange = (event) => {

    const linkValue = event.target.value;

    setLinkData({ ...linkData, gsUrl: linkValue });
    setDisableSave(false);


  };
  const handleDescriptionChange = (event) => {

    const descriptionValue = event.target.value;

    setOnboardingData({ ...onboardingData, manualCase: descriptionValue });
    setDisableSave(false);


  };

  const handleStatusChange = (e, { value }) => {

    setStatus(value)
    setDisableSave(false);

  };

  if (params.product === "cleverstory") {
    return null;
  }
  return (
    <Container className={styles.container}>
      <label className={cx(styles.title)}>On Boarding</label>
      <label></label>

      <Form>
        <FormField>
          <label className={cx(styles.manager)}>Manager</label>
          <Dropdown
            placeholder="Select a manager"
            value={accountObj?.onboardingUserId}
            options={managerOptions}
            onChange={(e, { value }) => {
              setAccountObj({ ...accountObj, onboardingUserId: value });
            }}
            className={styles.inputbox}
            selection
          />

        </FormField>

        <FormField className={styles.useCaseContainer}>
          <label>Use Case</label>

          <Select
            isMulti
            value={accountObj?.useCases}
            name="colors"
            options={useCaseOptions}
            className={cx("basic-multi-select")}
            classNamePrefix="select"
            onChange={handleUseCaseChange}
            placeholder="Select a usecases"
          />

        </FormField>

        <FormField>
          <label className={cx(styles.usecase)}>Description</label>
          <textarea
            placeholder="Add description..."
            className={cx(styles.inputboxarea)}
            onChange={handleDescriptionChange}
            value={onboardingData?.manualCase}
          />
        </FormField>

        <FormField>
          <label className={cx(styles.usecase)}>Status</label>
          <Dropdown
            className={cx(styles.inputbox)}
            placeholder="Select a status"
            selection
            options={statusOptions}
            value={status}
            onChange={handleStatusChange}
          />
        </FormField>
        <FormField>
          <label className={cx(styles.usecase)}>Template</label>
          <textarea
            placeholder="Add Link..."
            className={cx(styles.inputLink)}
            onChange={handleLinkChange}
            value={linkData?.gsUrl}
          />
        </FormField>
       
      </Form>



      <div className={cx(styles.buttonstyles)}>
        {error && <span className={styles.errorMessage}>
          <img src={exclamatory} height="14px" width="14px"
            alt="error" className={styles.errorIcon} />
          {error}</span>}
        <SaveChanges onClick={onSaveChanges} disabled={disableSave} />
        <Button className={cx(styles.cancelbutton)} onClick={onReset}>Reset</Button>
      </div>
      <ConfirmModal
        open={open}
        setOpen={setOpen}
        onSave={handleSubmit}
        onCancel={onCancelChanges}
        content={`Are you sure want to update ${account ? account.name : ""
          }?`}
      />
    </Container>
  );
}